import React, { useEffect, useState } from "react";
import DashboardUi from "./DashboardUi";
import Layout from "../../Components/Layout/Layout";
import { useDispatch, useSelector } from "react-redux";
import Loading from "../../Components/Loading/Loading";
import {
  useGetCentresQuery,
  useGetCityQuery,
  useGetRrbQuery,
  useGetStatesQuery,
} from "../../store/Api/common";
import { useGetDashboardQuery } from "../../store/Api/dashboard";
import { hidetoast, useDecodeToken } from "../../Utils/function";
import moment from "moment";
import  {rowsPerPage} from '../../Utils/constant'
import { useGetCenQuery } from "../../store/Api/cen";

function Dashboard() {
  const decodedToken = useDecodeToken();
  const selectedCEN = useSelector((state) => state.cen.selectedCEN);
  const [tableQaury, setTableQaury] = useState({
    search: "",
    rowsPerPage: rowsPerPage,
    currentPage: 1,
    cen_id: "",
    rrb_id: decodedToken?.role == 1 ? `${decodedToken?.rrb_id}` : "",
  });
  const [filtersId, setFiltersId] = useState({
    cen_id: "",
    rrbId: decodedToken?.role == 1 ? `${decodedToken?.rrb_id}` : "",
  });
  const { data: cenData } = useGetCenQuery({
    search: "",
    limit: "",
    page: "",
  });

  const { data: rrb } = useGetRrbQuery({});
  const [selectData, setSelectData] = useState({
    rrb: [],
  });
  const { data, isFetching, isLoading, refetch } = useGetDashboardQuery(
    {
      cen_id: tableQaury.cen_id ? tableQaury.cen_id : selectedCEN?.cenId,
      rrb_id: tableQaury.rrb_id ? tableQaury?.rrb_id : "",
    },
    // { skip: (decodedToken?.role != 3 || decodedToken?.role != 4 ) && !tableQaury.cen_id && !tableQaury.rrb_id  }
  );
  const dispatch = useDispatch();
  const toast = useSelector((state) => state.toast);
  useEffect(() => {
    setFiltersId({
      ...filtersId,
      cen_id: selectedCEN?.cenId,
    });
  }, [selectedCEN]);
  useEffect(() => {
    setFiltersId({
      ...filtersId,
      cen_id: selectedCEN?.cenId,
    });
  }, [selectedCEN]);

  // Auto-hide toast after 3 seconds
  useEffect(() => {
    if (toast.message) {
      hidetoast();
    }
  }, [toast.message, dispatch]);
  useEffect(() => {
    if (tableQaury?.cen_id || tableQaury?.rrb_id) {
      refetch();
    }
  }, [tableQaury]);

  useEffect(() => {
    setTableQaury({
      ...tableQaury,
      cen_id: filtersId?.cen_id,
    });
    if (filtersId?.rrbId) {
      setTableQaury({
        ...tableQaury,
        rrb_id: filtersId?.rrbId,
      });
    }
  }, [filtersId]);

  useEffect(() => {
    setSelectData({
      rrb: rrb?.data?.data,
    });
  }, [rrb]);

  const applyFilter = () => {
    setTableQaury({
      ...tableQaury,
      cen_id: filtersId?.cen_id,
    });
  };
  // const removeFilter = () => {
  //   // setFiltersId({
  //   //   ...filtersId,
  //   //   rrbId:"",
  //   // });

  //   setTableQaury((prev) => ({
  //     ...prev,
  //     rrb_id: "", // Clear only rrb_id
  //     cen_id: prev.cen_id
  //   }));

  //   setSelectData({
  //     rrb: rrb?.data?.data,
  //   });
  // };

  const removeFilter = () => {
    setFiltersId((prev) => ({
      ...prev,
      rrbId: "",
      cen_id: prev.cen_id,
    }));

    setTableQaury((prev) => ({
      ...prev,
      rrb_id: "",
      cen_id: prev.cen_id,
    }));

    setSelectData({
      rrb: rrb?.data?.data, // Reset rrb data if needed
    });
  };

  return (
    <Layout>
      {/* <Loading/> */}
      <DashboardUi
        data={data?.data}
        loading={isLoading}
        setFiltersId={setFiltersId}
        filtersId={filtersId}
        applyFilter={applyFilter}
        removeFilter={removeFilter}
        decodedToken={decodedToken}
        cenData={cenData?.data?.data}
        // areaChartOptions={areaChartOptions}
        // areaChartData={areaChartData}
        setSelectData={setSelectData}
        selectData={selectData}
      />
    </Layout>
  );
}

export default Dashboard;




// import React, { useEffect, useState } from "react";
// import DashboardUi from "./DashboardUi";
// import Layout from "../../Components/Layout/Layout";
// import { useSelector } from "react-redux";
// import { useGetRrbQuery } from "../../store/Api/common";
// import { useGetDashboardQuery } from "../../store/Api/dashboard";
// import { useDecodeToken } from "../../Utils/function";
// import { useGetCenQuery } from "../../store/Api/cen";

// function Dashboard() {
//   const decodedToken = useDecodeToken();
//   const selectedCEN = useSelector((state) => state.cen.selectedCEN);

//   // State for table query
//   const [tableQuery, setTableQuery] = useState({
//     search: "",
//     rowsPerPage: 10,
//     currentPage: 1,
//     cen_id: "",
//     rrb_id: decodedToken?.role === 1 ? `${decodedToken?.rrb_id}` : "",
//   });

//   // State for filters
//   const [filtersId, setFiltersId] = useState({
//     cen_id: "",
//     rrbId: decodedToken?.role === 1 ? `${decodedToken?.rrb_id}` : "",
//   });

//   const [selectData, setSelectData] = useState({
//         rrb: [],
//   });

//   // API queries
//   const { data: cenData } = useGetCenQuery({ search: "", limit: "", page: "" });
//   const { data: rrb } = useGetRrbQuery({});
//   const { data, isFetching, isLoading, refetch } = useGetDashboardQuery(
//     {
//       cen_id: tableQuery.cen_id ? tableQuery.cen_id : selectedCEN?.cenId,
//       rrb_id: tableQuery.rrb_id ? tableQuery.rrb_id : "",
//     },
//     { skip: !tableQuery.cen_id && !tableQuery.rrb_id }
//   );

//   // Set table query when filters change
//   useEffect(() => {
//     setTableQuery((prev) => {
//       if (
//         prev.cen_id !== filtersId.cen_id ||
//         prev.rrb_id !== filtersId.rrbId
//       ) {
//         return {
//           ...prev,
//           cen_id: filtersId.cen_id,
//           rrb_id: filtersId.rrbId,
//         };
//       }
//       return prev;
//     });
//   }, [filtersId]);

//   // Refetch dashboard data when filters are applied
//   useEffect(() => {
//     if (filtersId.cen_id || filtersId.rrbId) {
//       refetch();
//     }
//   }, [filtersId, refetch]);

//   // Prepare select data for dropdowns
//   useEffect(() => {
//     setSelectData({
//       rrb: rrb?.data?.data,
//     });
//   }, [rrb]);

//   // Apply filter
//   const applyFilter = () => {
//     setTableQuery((prev) => ({
//       ...prev,
//       cen_id: filtersId?.cen_id,
//     }));
//   };

//   // Remove filter
//   const removeFilter = () => {
//     setFiltersId((prev) => ({
//       ...prev,
//       rrbId: "",
//       cen_id: prev.cen_id,
//     }));

//     setTableQuery((prev) => ({
//       ...prev,
//       rrb_id: "",
//       cen_id: prev.cen_id,
//     }));
//   };

//   return (
//     <Layout>
//       <DashboardUi
//         data={data?.data}
//         loading={isLoading}
//         setFiltersId={setFiltersId}
//         filtersId={filtersId}
//         applyFilter={applyFilter}
//         removeFilter={removeFilter}
//         decodedToken={decodedToken}
//         cenData={cenData?.data?.data}
//         setSelectData={setSelectData}
//         selectData={{ rrb: rrb?.data?.data }}
//       />
//     </Layout>
//   );
// }

// export default Dashboard;